import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/global.scss';
import '@/assets/styles/element-theme.scss';
import api from '@/api/index.js';
import './service/index.js';
import '@/directives/importDirectives.js';

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$api = api;

function setTitle(meta) {
  window.document.title = meta.title;
}

router.beforeEach((to, from, next) => {
  localStorage.setItem('clock_in_active_path', to['name']);
  let token = localStorage.getItem('clock_in_token');
  const {
    meta,
    meta: { needLogin },
  } = to;
  if (needLogin) {
    if (token) {
      setTitle(meta);
      next();
    } else {
      setTitle(meta);
      next({
        path: '/login',
      });
    }
  } else {
    setTitle(meta);
    next();
  }
});
window.$vue = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
